const Model = require("../types/Model.js");

module.exports = Model({
	name: "logout",
	init,
	uninit,
	triggers
});

function init() {
	this.push({});
	this._steps = {};
}

function uninit(){
	this._steps = {};
}

function triggers() {
	return {
		"setup": handle_trigger_setup,
		"logout": handle_trigger_logout,
		"finish": handle_finished
	};
}

function handle_trigger_setup(data){
	this._steps[data.type] = false;
}

function handle_trigger_logout(){
	this.emit("remotepushhandler:trigger:logout");
	this.emit("personal:trigger:logout");
}

function handle_finished(data){
	if(data.type){
		this._steps[data.type] = true;
	}

	const shouldComplete = Object.keys(this._steps).length > 0 ? Object.values(this._steps).every(e => e) : true;

	if(shouldComplete){
		this.emit("app:trigger:logout");
		this._steps = {};
	}

	shouldComplete && this.emit("usermetrics:trigger:track", "logout");
}